module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-03@2x.f4b4bf88.jpg";